// removed by extract-text-webpack-plugin
module.exports = {"Room":"_27EmBParnmIy9tQcQHC9O2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Rooms/Room/Room.css
// module id = 249
// module chunks = 0